import { InsightsTab } from '../utils'

const monthDayOptions = { month: 'long', day: 'numeric' } as const

// If the tab is 'yesterday', we want to display "[Month] [Day]"
// If the tab is 'weekly', we want to display "[Month] [Day] - [Day]" or "[Month] [Day] - [Month] [Day]"
// Example outputs:
// "June 5th"
// "June 3rd - 9"
// "June 29th - July 5th"
export const determineSummaryDisplayDate = (
    isYesterdayTab: boolean,
    startDate?: string,
    endDate?: string,
) => {
    if (!startDate) return ''

    if (isYesterdayTab) {
        const yesterday = parseDateOnlyLocal(startDate)
        return yesterday.toLocaleDateString('en-US', monthDayOptions)
    }

    const startOfWeek = parseDateOnlyLocal(startDate)
    const endOfWeek = endDate ? parseDateOnlyLocal(endDate) : undefined

    const startMonth = startOfWeek.toLocaleDateString('en-US', {
        month: 'long',
    })
    const endMonth = endOfWeek?.toLocaleDateString('en-US', {
        month: 'long',
    })

    if (startMonth === endMonth) {
        const endDay = endOfWeek ? ` - ${endOfWeek.getDate()}` : ''
        return `${startMonth} ${getOrdinal(startOfWeek.getDate())}${endDay}`
    }
    const endDay = endOfWeek
        ? ` - ${endMonth} ${getOrdinal(endOfWeek.getDate())}`
        : ''
    return `${startMonth} ${getOrdinal(startOfWeek.getDate())}${endDay}`
}

const getOrdinal = (day: number) => {
    if (day >= 11 && day <= 13) return `${day}th`

    switch (day % 10) {
        case 1:
            return `${day}st`
        case 2:
            return `${day}nd`
        case 3:
            return `${day}rd`
        default:
            return `${day}th`
    }
}

// We don't care about timezones, just want the raw date
const parseDateOnlyLocal = (value: string) => {
    const [year, month, day] = value.split('-').map(Number)
    // Date constructor treats month as 0-indexed, so we subtract 1 from month
    return new Date(year, month - 1, day)
}

export const getImagePathAndClass = (tab: InsightsTab, hasData: boolean) => {
    const valuesFromTab = TrailingImagePathAndClass[tab]
    return hasData ? valuesFromTab.withData : valuesFromTab.withoutData
}

export const TrailingImagePathAndClass = {
    [InsightsTab.Yesterday]: {
        withData: {
            path: '/insights/Scenery.svg',
            classnames: {
                font: 'summary-font-light',
                card: 'summary-card-yesterday',
            },
        },
        withoutData: {
            path: '/insights/Scenery_Black_and_White.svg',
            classnames: {
                font: 'summary-font-dark',
                card: 'summary-card-no-data',
            },
        },
    },
    [InsightsTab.Weekly]: {
        withData: {
            path: '/insights/Computer_Desk.svg',
            classnames: {
                font: 'summary-font-dark',
                card: 'summary-card-weekly',
            },
        },
        withoutData: {
            path: '/insights/Computer_Desk_Black_and_White.svg',
            classnames: {
                font: 'summary-font-dark',
                card: 'summary-card-no-data',
            },
        },
    },
}
